<template>
	<div class="page-main">
		<!-- <nav-bar title="二维码" :border="false" :left-arrow="true" @click-left="pageBack"></nav-bar> -->
	
		
		
		<div class="page-header">
			<img src="~@/assets/xinxi.png" class="info-icon" @click="handleMessageClick" />
		</div>
		<div class="qrcode">
			<img class="img" :src="qrcode" />
		</div>
		<div class="card-bottom">
			<p>使用星礼卡，同步支付积星星</p>
			<router-link to="/main">获取一张星礼卡</router-link>
		</div>
		<!-- <div class="card-box">

          <img src="~@/assets/ic_fresh_new_logo.png" class="logo"/>
        <div class="qrcode">
            <img class="img" :src="qrcode"/>
            <div class="p">二维码每30秒自动更新</div>
        </div>
        
        
        <div class="bottom">
            <img class="img" src="~@/assets/member_rewards_bg.png"/>
            <div class="p">使用星礼卡，同步支付积星星</div>
        </div>
        
          
      </div> -->

	</div>
</template>

<script>
	// import {navBar} from "vant";
	import {
		getQr,
		find_email_questionnaire
	} from "@/api";
	import store from "../../store";
	export default {
		data() {
			return {
				qrcode: null,
				timer: null,
				cardNum: store.state.cardNum,
			}
		},
		created() {
			this.getQrcode();
			//this.time = setInterval(this.getQrcode,15000);
		},
		methods: {
			getQrcode() {
				getQr(this.cardNum).then(d => {
					this.qrcode = "data:image/png;base64," + d.data.qr;
					this.timer = setTimeout(() => {
						this.getQrcode();
					}, d.data.time_out * 1000);

				})
			},
			pageBack() {
				window.history.back();
			},
			handleMessageClick() {
				find_email_questionnaire().then(res => {
					if (res.stat && res.data && res.data.url) {
						window.location.href = res.data.url;
					} else {
						this.$toast(res.message || '未查询到问卷');
					}
				}).catch(err => {
					this.$toast('请求失败');
					console.error('请求失败', err);
				});
			}
		},
		// components:{
		//     navBar
		// },
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-main {
		min-height: 100vh;
		

		::v-deep .van-nav-bar {
			background: transparent;

			.van-nav-bar__title,
			.van-nav-bar__left .van-icon {
				color: #fff !important;
			}

		}

		.page-header {
			height: 409px;
			background: url('~@/assets/header.jpg') no-repeat;
			background-size: 100% 100%;
			position: relative;
		}

		.info-icon {
			position: absolute;
			top: 30px;
			right: 30px;
			width: 40px;
			height: 40px;
			z-index: 1;
		}

		.qrcode {
			padding: 50px 0 40px;
			text-align: center;

			.img {
				width: 400px;
				height: 400px;
				margin: auto;
				margin-bottom: 30px;
			}
		}

		.card-bottom {
			text-align: center;

			a {
				color: #45aa69;
				font-size: 30px;
			}
		}

		.card-box {
			background: #fff;
			margin: 30px;
			border-radius: 16px;
			padding-top: 60px;
			position: relative;

			&::before,
			&::after {
				content: "";
				position: absolute;
				width: 50px;
				height: 50px;
				border-radius: 50%;
				background: #666;
				top: 692px;
			}

			&::before {
				right: -25px;
			}

			&::after {
				left: -25px;
			}

			.logo {
				width: 100px;
				height: 100px;
				margin: auto;
			}

			img {
				display: block;
			}



			.p {
				font-size: 24px;
				text-align: center;
				color: #666;
			}

			.bottom {
				padding: 30px 0 50px;
				border-top: 1px dashed #ddd;

				img {
					width: 60%;
					margin: auto;
					margin-bottom: 20px;
				}

				.p {
					text-align: center;
					font-size: 24px;
				}
			}
		}
	}
</style>